import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page, TodoList } from '../../shared';

import ReactTooltip from 'react-tooltip';

import {
  UpdateDealModal,
  TrackImperativeTaskModal,
  TrackFunnelTaskModal,
} from '../../modals';

import { getIcon } from '../../../util/icons';
import {
  getSevenImperative,
  getSevenImperatives,
  getImperativesStages } from '../../../util/data';

import {
  isDevelopment,
  formatThousands,
  generateUnsafeHash,
  getCurrentTime,
  getDealCompletion,
  getClassModifierForConfidence,
} from '../../../util';

import {
  fetchDeal,
  fetchDealsForEmployee,
  updateDeal,

} from '../../../actions/deals';

import { MessageModal } from '../../modals';

import KeyRisks from './keyRisks';
import ActionItems from './actionItems';

class ImperativesDealPage extends Component {

  state = {
    pageMessage: null,
    updatingDeal: false,
    expandedImperatives: {
      //none to start
    },
    expandedStages: {
      '1': true,
      '2': true,
      '3': true,
      '4': true
    },
    trackingImperativeTask: null,
    syncingImperativeTask: false,
    trackingFunnelTask: null,
    syncingFunnelTask: false,
    imperativeSummaries: {
      '1': '', '2': '', '3': '', '4': '', '5': '', '6': '', '7': ''
    },
    syncingImperativeSummary: null,
    viewingImperativeDiscoveryQuestions: null,
  }

  mapDealToState(deal){

    // console.log('getStageStatus::1:: ', this.getStageStatus('1'));
    // console.log('getStageStatus::2:: ', this.getStageStatus('2'));
    // console.log('getStageStatus::3:: ', this.getStageStatus('3'));
    // console.log('getStageStatus::4:: ', this.getStageStatus('4'));

    this.setState({
      imperativeSummaries: {
        ...this.state.imperativeSummaries,
        ...deal.imperativeSummaries
      },
      expandedStages: {
        '1': this.getStageStatus('1') !== 'complete',
        '2': this.getStageStatus('2') === 'in_progress',
        '3': this.getStageStatus('3') === 'in_progress',
        '4': this.getStageStatus('4') === 'in_progress',
      }
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    // console.log('PAGE received new props: ', this.props);

    const { match: { params } } = this.props;

    if(prevProps.deal && prevProps.deal._id !== params.dealId && !this.props.loadingDeal){
      // console.log('fetching deal since deal component updated');
      this.props.fetchDeal(params.dealId, this.mapDealToState.bind(this));
    }
  }

  componentWillMount(){
    // console.log('Deal component will mount');

    const { match: { params } } = this.props;

    let employeeId = params.employeeId;
    const dealId = params.dealId;

    //if no employeeId...user accessing sprint
    //TODO figure out a better way of managing this
    if(employeeId){
      this.setState({
        employeeId,
        isOwnDeals: false,
      })
    }
    else{
      employeeId = this.props.user.uid;

      this.setState({
        employeeId,
        isOwnDeals: true,
      });
    }

    this.props.fetchDeal(dealId, this.mapDealToState.bind(this));

    //also fetch deals if unloaded (for nav menu)
    if(!this.props.deals){
      this.props.fetchDealsForEmployee(employeeId);
    }
  }

  updateImperativeTaskStatus(id, newStatus){

    if(this.state.syncingImperativeTask === id){
      return;
    }
    this.setState({
      syncingImperativeTask: id
    });

    let dealToSave = { ...this.props.deal };

    dealToSave.imperativeTasks = {
      ...dealToSave.imperativeTasks,
      [id]: newStatus
    }

    this.props.updateDeal(dealToSave, updatedDeal => {
      this.setState({
        syncingImperativeTask: null,
        trackingImperativeTask: null
      });
    });
  }

  renderTrackImperativeTaskModal(){

    const { trackingImperativeTask, syncingImperativeTask } = this.state;

    if(!trackingImperativeTask){
      return null;
    }

    return <TrackImperativeTaskModal
      imperativeName={getSevenImperative(trackingImperativeTask.imperative).name}
      imperativeTask={trackingImperativeTask}
      hide={() => { this.setState({ trackingImperativeTask: null }); }}
      updateStatus={newStatus => { this.updateImperativeTaskStatus(trackingImperativeTask.id, newStatus); }}
      syncingImperativeTask={syncingImperativeTask}
      currentTaskStatus={this.getImperativeTaskStatus(trackingImperativeTask.id)}
    />
  }
  trackImperativeTask(imperativeTask){
    this.setState({
      trackingImperativeTask: imperativeTask
    });
  }

  updateFunnelTaskStatus(id, newStatus){

    if(this.state.syncingFunnelTask === id){
      return;
    }
    this.setState({
      syncingFunnelTask: id
    });

    let dealToSave = { ...this.props.deal };

    dealToSave.funnelTasks = {
      ...dealToSave.funnelTasks,
      [id]: newStatus
    }

    //contract signed - deal is now won
    if(id === '118' && newStatus == 'complete'){
      dealToSave.status = 'won';
    }
    //contract was signed, now marked not signed, deal goes to open
    else if(id === '118' && newStatus != 'complete'){
      if(dealToSave.status === 'won'){
        dealToSave.status = 'open';
      }
    }

    this.props.updateDeal(dealToSave, updatedDeal => {
      this.setState({
        syncingFunnelTask: null,
        trackingFunnelTask: null
      });
    });
  }

  getImperativeTask(id){
    const allImperativeItems = _.flatMap(getSevenImperatives(), 'tasks');

    return _.find(allImperativeItems, { id }) || null;
  }

  renderTrackFunnelTaskModal(){
    const { trackingFunnelTask, syncingFunnelTask } = this.state;

    if(!trackingFunnelTask){
      return null;
    }

    return <TrackFunnelTaskModal
      funnelTask={trackingFunnelTask}
      hide={() => { this.setState({ trackingFunnelTask: null }); }}
      updateStatus={newStatus => { this.updateFunnelTaskStatus(trackingFunnelTask.id, newStatus); }}
      syncingFunnelTask={syncingFunnelTask}
      currentTaskStatus={this.getFunnelTaskStatus(trackingFunnelTask)}
    />
  }
  trackFunnelTask(funnelTask){
    if(funnelTask.imperativeId){
      this.expandImperative(funnelTask.imperativeId, true);
    }
    else if(funnelTask.imperativeTaskId){
      this.trackImperativeTask(this.getImperativeTask(funnelTask.imperativeTaskId));
    }
    else{
      this.setState({
        trackingFunnelTask: funnelTask
      });
    }
  }
  quickCompleteFunnelTask(funnelTask){
    if(funnelTask.imperativeId){
      this.expandImperative(funnelTask.imperativeId, true);
    }
    else if(funnelTask.imperativeTaskId){
      this.updateImperativeTaskStatus(funnelTask.imperativeTaskId, 'complete');
    }
    else{
      this.updateFunnelTaskStatus(funnelTask.id, 'complete');
    }
  }

  expandImperative(imperativeId, onlyExpand = false){
    this.setState({
      expandedImperatives: {
        ...this.state.expandedImperatives,
        [imperativeId]: !this.state.expandedImperatives[imperativeId] || onlyExpand
      }
    });
  }

  expandStage(stageId){
    this.setState({
      expandedStages: {
        ...this.state.expandedStages,
        [stageId]: !this.state.expandedStages[stageId]
      }
    });
  }

  getImperativeTaskStatus(id){
    const item = (this.props.deal.imperativeTasks || {})[id];

    if(item === 'complete'){
      return 'complete';
    }
    else if(item === 'failed'){
      return 'failed';
    }
    else{
      return 'incomplete';
    }
  }
  getImperativeStatus(id){
    //let hasFailedTask = false;
    let allTasksComplete = true;

    // console.log('checking imperative status: ', id);

    _.each(getSevenImperative(id).tasks, task => {
      const taskStatus = this.getImperativeTaskStatus(task.id);
      // console.log(`subtask [${task.id}]: ${taskStatus}`);
      if(taskStatus !== 'complete'){
        //hasFailedTask = true;
        allTasksComplete = false;
      }
    });

    return allTasksComplete ? 'complete' : 'incomplete';
  }
  getFunnelTaskStatus(funnelTask){

    if(funnelTask.imperativeId){
      //check if imperative is complete
      return this.getImperativeStatus(funnelTask.imperativeId);
    }
    else if(funnelTask.imperativeTaskId){
      //check if imperative item is complte
      return this.getImperativeTaskStatus(funnelTask.imperativeTaskId)
    }
    else{
      const item = (this.props.deal.funnelTasks || {})[funnelTask.id];

      if(item === 'complete'){
        return 'complete';
      }
      else if(item === 'failed'){
        return 'failed';
      }
      else{
        return 'incomplete';
      }
    }
  }

  localImperativeSummary(id){
    const item = this.state.imperativeSummaries[id];

    return item || '';
  }
  serverImperativeSummary(id){
    const item = (this.props.deal.imperativeSummaries || {})[id];

    return item || '';
  }
  imperativeSummaryIsDirty(id){
    return this.localImperativeSummary(id) !== this.serverImperativeSummary(id);
  }

  renderImperativeTask(imperativeTask){
    const { id, text, imperative } = imperativeTask;

    const itemStatus = this.getImperativeTaskStatus(id);

    const isComplete = itemStatus === 'complete';
    const isFail = itemStatus === 'failed';
    const isIncomplete = itemStatus === 'incomplete';

    return (
      <li
        onClick={(e) => { e.stopPropagation(); this.trackImperativeTask(imperativeTask); return false; }}
        key={id}
        className={`imperative-item ${itemStatus}`}
      >
        <div className="imperative-item-text">{text}</div>
        <div
          onClick={(e) => { if(isIncomplete){ e.stopPropagation(); this.updateImperativeTaskStatus(id, 'complete'); return false; }  }}
          className="imperative-item-check">{isComplete ? getIcon('check-fill') : (isFail ? getIcon('check-fail') : getIcon('check-empty'))}</div>
      </li>
    );
  }

  updateLocalImperativeSummary(id, newSummary){
    this.setState({
      imperativeSummaries: {
        ...this.state.imperativeSummaries,
        [id]: newSummary
      }
    });
  }

  saveImperativeSummaryChanges(id){
    if(this.state.syncingImperativeSummary === id){
      return;
    }
    this.setState({
      syncingImperativeSummary: id
    });

    let dealToSave = { ...this.props.deal };

    dealToSave.imperativeSummaries = {
      ...dealToSave.imperativeSummaries,
      [id]: this.localImperativeSummary(id)
    }

    this.props.updateDeal(dealToSave, updatedDeal => {
      this.setState({
        syncingImperativeSummary: null,
      });
    });
  }

  handleQuickSummaryKeyDown(e, id){
    // console.log('e: ', e);
    // console.log('e.key: ', e.key);

    // console.log('e.ctrlKey: ', e.ctrlKey);
    // console.log('e.altKey: ', e.altKey);
    // console.log('e.shiftKey: ', e.shiftKey);
    // console.log('e.metaKey: ', e.metaKey);
    //console.log('e: ', e);

    const modifierKeyPressed = e.ctrlKey || e.altKey || e.shiftKey || e.metaKey;

    if(e.key === 'Escape'){
      e.preventDefault();
      this.setState({
        imperativeSummaries: {
          ...this.state.imperativeSummaries,
          ...this.props.deal.imperativeSummaries,
        }
      });
    }
    if(e.key === 'Enter' && modifierKeyPressed){
      e.preventDefault();
      this.saveImperativeSummaryChanges(id);
    }
  }

  viewDiscoveryQuestions(imperative){
    this.setState({
      viewingImperativeDiscoveryQuestions: imperative
    });
  }

  renderImperative(imperative){

    const { expandedImperatives } = this.state;

    const { name, id, summaryQuestion, tasks, questions } = imperative;

    const summary = this.localImperativeSummary(id);

    const imperativeTasksComplete = _.reduce(tasks, (memo, task) => {
      return memo + (this.getImperativeTaskStatus(task.id) === 'complete' ? 1 : 0);
    }, 0);

    return (
      <div
        onClick={() => { this.expandImperative(id); }}
        key={id}
        className={`imperative imperative-${id} ${expandedImperatives[id] ? ' expanded' : ''}`}
      >
        <div className="imperative-name">{name}</div>
        <div className="imperative-score">{imperativeTasksComplete}/5</div>

        <div
          className="imperative-details"
          onClick={(e) => { e.stopPropagation(); return false; }}
        >
          <div className="imperative-summary">
            <h6>Quick summary</h6>
            <textarea
              onKeyDown={e => { this.handleQuickSummaryKeyDown(e, id); } }
              className="summary-text"
              placeholder={summaryQuestion}
              value={summary}
              onChange={(e) => { this.updateLocalImperativeSummary(id, e.target.value); }}
            ></textarea>
          {this.imperativeSummaryIsDirty(id) &&
            <div className="update-summary-action">
              <span className="save-shortcut-explanation">(SHIFT + &crarr;)</span>
                <button
                  disabled={this.state.syncingImperativeSummary === id}
                  onClick={() => { this.saveImperativeSummaryChanges(id); }}
                  className="button primary button-micro">
                  {this.state.syncingImperativeSummary !== id &&
                    <span>SAVE</span>
                  }
                  {this.state.syncingImperativeSummary === id &&
                    <span>SAVING...</span>
                  }
                </button>
            </div>
          }
          </div>
          <div className="imperative-items">
            <h6>Checklist</h6>
            {_.map(tasks, this.renderImperativeTask.bind(this))}
          </div>
          <div className="imperative-resources">
            <h6>Resources</h6>
            <div
              onClick={() => { this.viewDiscoveryQuestions(imperative); }}
              className="resource">
              {getIcon('questions')}
              <div className="resource-name">Discovery questions</div>
            </div>
            {isDevelopment() &&
              <div className="resource">
                {getIcon('questions')}
                <div className="resource-name">Common objections</div>
              </div>
            }
            {isDevelopment() &&
              <div className="resource">
                {getIcon('edit')}
                <div className="resource-name">Notes</div>
              </div>
            }
          </div>
        </div>
        <div className="toggle-expand-arrow">{getIcon('chevron-down')}</div>
      </div>
    );
  }

  renderImperativesSummary(){
    const imperatives = getSevenImperatives();

    return(
      <div className="imperatives-summary">
        <h2>Seven Imperatives</h2>

        <div className="imperatives-list">
          {_.map(imperatives, this.renderImperative.bind(this))}
        </div>
      </div>
    );
  }

  getStageStatus(stageId){

    const stages = getImperativesStages();
    const stageObjectives = _.filter(stages.objectives, { 'stage': stageId });
    const stageReciprocations = _.filter(stages.reciprocations, { 'stage': stageId });

    let stageIsComplete = true;
    let stageIsStarted = false;

    _.each(_.union(stageObjectives, stageReciprocations), funnelTask => {
      if(this.getFunnelTaskStatus(funnelTask) && this.getFunnelTaskStatus(funnelTask) !== 'incomplete'){
        stageIsStarted = true;
      }
      if(this.getFunnelTaskStatus(funnelTask) !== 'complete'){
        stageIsComplete = false;
      }
    });

    if(stageIsComplete){
      return 'complete';
    }
    else if(stageIsStarted){
      return 'in_progress';
    }
    else{
      return 'not_started';
    }
  }

  renderFunnelTask(funnelTask){

    const { id, stage, imerativeItem, imperative, text} = funnelTask;

    const itemStatus = this.getFunnelTaskStatus(funnelTask);

    const isComplete = itemStatus === 'complete';
    const isFail = itemStatus === 'failed';
    const isIncomplete = itemStatus === 'incomplete';

    return(
      <div
        onClick={(e) => { e.stopPropagation(); this.trackFunnelTask(funnelTask); return false; }}
        key={id}
        className={`stage-item stage-item-${id} ${itemStatus}`}
      >
      <div
        onClick={(e) => { if(isIncomplete){ e.stopPropagation(); this.quickCompleteFunnelTask(funnelTask); return false; }}}
        className="stage-item-check">{isComplete ? getIcon('check-fill') : (isFail ? getIcon('check-fail') : getIcon('check-empty'))}</div>
        <div className="stage-item-text">{text}</div>
      </div>
    )
  }
  renderStage(stage){
    const { expandedStages } = this.state;

    const { name, id } = stage;

    const stages = getImperativesStages();
    const stageObjectives = _.filter(stages.objectives, { 'stage': id });
    const stageReciprocations = _.filter(stages.reciprocations, { 'stage': id });

    const stageTotal = stageObjectives.length + stageReciprocations.length;

    const stageCompleteCount = _.reduce(_.union(stageObjectives, stageReciprocations), (memo, task) => {
      return memo + (this.getFunnelTaskStatus(task) === 'complete' ? 1 : 0);
    }, 0);

    let stageComplete = this.getStageStatus(id) === 'complete';

    return (
      <div
        key={id}
        className={`stage ${expandedStages[id] ? ' expanded' : ''}`}
      >
        <div className="stage-name">{name} ({stageCompleteCount}/{stageTotal})</div>
        <div
          onClick={() => { this.expandStage(id); }}
          className={`click-to-expand ${stageComplete ? ' complete' : ''}`}>{stageComplete && getIcon('check-fill')}{stageComplete ? 'Stage complete. Click to show details...' : 'Stage not yet started. Click to show details...'}</div>
        <div className="stage-item-group">
          <h6>Objectives</h6>
          {_.map(stageObjectives, this.renderFunnelTask.bind(this))}
        </div>
        <div className="stage-item-group">
          <h6>Reciprocations</h6>
          {_.map(stageReciprocations, this.renderFunnelTask.bind(this))}
        </div>

        {parseInt(id) < 4 &&
          <div className="arrow-to-next-stage">{getIcon('chevron-down')}</div>
        }
        {id === '4' && this.renderWonDealLink()}
      </div>
    );
  }

  renderWonDealLink(){
    const { deal } = this.props;

    if(!deal || deal.status === 'won'){ return null; }

    return <div
      onClick={this.beginUpdatingDeal.bind(this)}
      className="deal-won-prompt">Won this deal?</div>;
  }

  renderBuyingStage(){

    const stages = getImperativesStages().stages;

    return(
      <div className="buying-stage">
        <h2>Deal Stage</h2>
        <div className="stages">
          {_.map(stages, this.renderStage.bind(this))}
        </div>
      </div>
    );
  }

  renderDealInfo(){

    const { loadingDeal, deal } = this.props;

    if(loadingDeal || !deal){
      return null;
    }

    const { name, estimatedValue, estimatedCloseDate, product, lastUpdated } = deal;

    return (
      <div className="deal-info">
        <h1>{name}</h1>
        <h3>Est Deal Size: ${formatThousands(estimatedValue)}</h3>
        <p>Solution/Product: {product}</p>
        {lastUpdated &&
          <p>Last Updated: {moment(lastUpdated.toDate()).format('MM/DD/YYYY')}</p>
        }
        <p>Est close date: {moment(estimatedCloseDate).format('MM/DD/YYYY')}</p>
        <p onClick={this.beginUpdatingDeal.bind(this)} className="edit">edit details</p>
      </div>
    );
  }

  renderDealStatus(){
    const { loadingDeal, deal } = this.props;

    if(loadingDeal || !deal){
      return null;
    }

    const { status } = deal;

    return (
      <div
        onClick={this.beginUpdatingDeal.bind(this)}
        className={`deal-status-label ${status}`}>
        <span className="current-status">{status.toUpperCase()}</span>
        <span className="change-status">UPDATE</span>
      </div>
    );
  }

  renderDealConfidence(){

    const dealCompletion = getDealCompletion(this.props.deal);

    if(!dealCompletion){ return null; }

    // console.log('dealCompletion: ', dealCompletion);

    const { fractionComplete, percentComplete, confidence } = dealCompletion;

    return (
      <div className="deal-confidence">
        <div className="amount">{confidence}%</div>
        <div className="progress-bar">
          <div className={`progress ${getClassModifierForConfidence(confidence)}`} style={{width: `${confidence}%`}}></div>
        </div>
        <div className="label" data-tip="Deal confidence helps gauge how far along deals are compared to one another and does not represent a precise probability to close">{getIcon('info-bold')} Deal Confidence</div>
        <div className="items-complete">Items Completed: {percentComplete}%</div>
        <ReactTooltip effect="solid" place="top" />
      </div>
    );
  }

  renderKeyRisks(){

    const { keyRisks } = this.props.deal;

    return (
      <div className="key-risks">
        <h2>Key Risks</h2>
          <KeyRisks
            deal={this.props.deal}
            keyRisks={keyRisks}
            updateDeal={this.props.updateDeal}
          />
      </div>
    );
  }
  renderActionItems(){

    const { actionItems } = this.props.deal;

    return (
      <div className="key-risks">
        <h2>Action Items</h2>
          <ActionItems
            deal={this.props.deal}
            actionItems={actionItems}
            updateDeal={this.props.updateDeal}
          />
      </div>
    );
  }

  afterDealUpdate(){
    this.setState({
      updatingDeal: null
    });
  }

  beginUpdatingDeal(){
    this.setState({
      updatingDeal: { ...this.props.deal }
    });
  }

  renderPageLeftSection(){
    return(
      <div className="page-section-left">
        {this.renderKeyRisks()}
        {this.renderActionItems()}
        {this.renderImperativesSummary()}
      </div>
    )
  }
  renderPageRightSection(){
    return(
      <div className="page-section-right">
        {this.renderBuyingStage()}
      </div>
    )
  }

  renderDiscoveryQuestionsModal(){
    const { viewingImperativeDiscoveryQuestions } = this.state;

    if(!viewingImperativeDiscoveryQuestions){
      return null;
    }

    const questionsAsList = _.reduce(viewingImperativeDiscoveryQuestions.questions, (memo, question) => {
      return memo + `<li>${question.text}</li>`;
    }, '')
    const messageHtml = `
      <h2 style="margin-top:0px;">${viewingImperativeDiscoveryQuestions.name}</h2>
      <ul class="default-style-list large-items">${questionsAsList}</ul>
    `;

    return(
      <MessageModal
        visible={viewingImperativeDiscoveryQuestions}
        iconKey={'questions'}
        messageHtml={messageHtml}
        hide={() => { this.setState({ viewingImperativeDiscoveryQuestions: null }); }}
      />
    )
  }

  render(){

    const loading = !this.props.user || this.props.loadingDeal | !this.props.deal;

    return (
      <Page
        pageClass="imperatives"
        loading={loading}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        {this.renderDealInfo()}
        {this.renderDealConfidence()}
        {this.renderDealStatus()}

        <div className="page-content">
          <div className="page-section top-border">
            {!loading && this.renderPageLeftSection()}
            {!loading && this.renderPageRightSection()}
          </div>
        </div>

        {this.renderTrackImperativeTaskModal()}
        {this.renderTrackFunnelTaskModal()}
        {this.renderDiscoveryQuestionsModal()}

        <UpdateDealModal
          hide={() => { this.setState({ updatingDeal: null }) }}
          editingDeal={this.state.updatingDeal}
          visible={!!this.state.updatingDeal}
          onUpdate={this.afterDealUpdate.bind(this)}
        />
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    deal: state.deal.data,
    deals: state.deals.data,
    loadingDeal: state.deal.loading,
  }
}

export default connect(mapStateToProps, { fetchDeal, fetchDealsForEmployee, updateDeal })(ImperativesDealPage);



// WEBPACK FOOTER //
// ./src/components/imperatives/deal/index.js